import { jsx } from '@emotion/react';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useData } from './Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { link_more } from 'components/langutils';
import { CacheProvider, css } from '@emotion/react'
import { PictureTile, teaserOf, tilePictures } from './UzlDesign';
import { recordTeaser } from './langutils';
import createCache from '@emotion/cache'

export const TeaserBack = styled('div')({
  width: '200px',
  height: '200px',
  borderRadius: '6px',
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  color: 'rgb(240, 240, 240)',
  boxShadow: '0 10px 30px 5px rgba(0, 0, 0, 0.2)',
  backgroundColor: '#222222',
  '&:hover h2': {
    inset: 'auto auto 170px 12px',
    transition: 'inset .3s ease-out, opacity .3s ease-out',
    opacity: 1,
  },
  '&:hover p, &:hover a': {
    opacity: 1,
    transition: 'opacity .5s .1s ease-in',
  },
  '&:hover img': {
    transform: 'scale(1.15)',
    transition: 'opacity .5s ease-in, transform .3s ease-in, filter .3s ease-in',
    opacity: 0.2,
    filter: 'blur(5px)',
  },
});

export const TeaserImg = styled('img')({
  position: 'absolute',
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  opacity: 0.5,
  transition: 'opacity .2s ease-out, transform .2s ease-out',
});

export const TeaserBody = styled('p')({
  position: 'absolute',
  opacity: 0,
  maxWidth: '90%',
  maxHeight: '130px',
  transition: 'opacity .3s ease-out',
  inset: 'auto auto 24px 12px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const TeaserLink = styled('span')({
  position: 'absolute',
  opacity: 0,
  maxWidth: '80%',
  transition: 'opacity .3s ease-out',
  inset: 'auto auto 12px 12px',
  color: 'inherit',
  textDecoration: 'none',
});

export const TeaserHeader = styled('h2')({
  position: 'absolute',
  inset: 'auto auto 12px 12px',
  margin: 0,
  transition: 'inset .3s .3s ease-out',
  fontFamily: "'Roboto Condensed', sans-serif",
  fontWeight: 'normal',
  textTransform: 'uppercase',
});

export const TeaserOverlay = styled('div')({});

export function TeaserTile({ obj, url }: any) {
  const { lang } = useData();
  const { image, logo } = tilePictures(obj);
  return (
    <PictureTile href={url} title={obj[`title_${lang}`] ?? obj.name}
      teaser={recordTeaser(obj, lang) ?? teaserOf(obj[`description_${lang}`], 140)} image={image} logo={logo} />
  );
}

export function Tile({title, image, url, styleRoot}: any) {
  const { lang } = useData();
  const myCache = createCache({
    key: 'tiles', container: styleRoot
  })
  useEffect(() => {
    return () => {
      myCache.sheet.flush();
      (myCache.inserted as any) = [];
      myCache.registered = {};
    }
  })
  return (
    <CacheProvider value={myCache}>
      <a href={url} style={{
        margin: '4px',
      }}>
        <TeaserBack>
          <TeaserImg src={image} />
          <TeaserOverlay>
            <TeaserHeader>
              {title}
            </TeaserHeader>
            <TeaserBody><slot name='default'/></TeaserBody>
            <TeaserLink>
              {link_more(lang)}
              <FontAwesomeIcon style={{width: '0.8em'}} icon={faArrowRight} />
            </TeaserLink>
          </TeaserOverlay>
        </TeaserBack>
      </a>
    </CacheProvider>
  );
}
